import Phaser from 'phaser';
import { assetsToPreload } from '../assets-to-load';
import { app } from '../core/App';
import { SceneId, TransitionPoint } from '../rooting';
import BaseScene from '../core/scenes/BaseScene';

export default class Boot extends BaseScene {
  constructor() {
    super('Boot');
  }

  preload() {
    app.beforePreload();
    assetsToPreload(this);
  }

  create() {
    if (!__IS_PRODUCTION__) this.scene.launch(SceneId.DebugUI, { test: 'test' });
    app.gotoNextScene(this, TransitionPoint.BootEnd, { test: 'test' });
  }
}
